import React from 'react';
export const CTAButton = ({
  text = 'Find Your Size & Get a Pair — 60‑Day Guarantee',
  secondary = false
}) => {
  return <div className="w-full flex justify-center my-8" data-id="element-93">
      <a href="https://silentstruggle.shop/ardava-checkout" className="to-checkout" data-pass-params="1" data-id="element-94">
        <button className={`${secondary ? 'bg-teal-700' : 'bg-teal-600'} hover:bg-teal-700 text-white font-medium px-8 py-3 rounded-md text-lg shadow-md`} data-id="element-95">
          {text}
        </button>
        <p className="text-xs text-gray-500 mt-2 text-center" data-id="element-96">
          Price locks at checkout · This week's batch ships Friday
        </p>
      </a>
    </div>;
};